import { useTranslation } from "react-i18next";
import { useProjectStoreContext } from "@/modules/projects/components/ProjectStoreContext";
import { useCallback, useMemo } from "react";
import { AdditionalResetItem } from "@/components/list/components/ListResetMenuBarMenu";
import { List } from "@/components/list/List";

export const ProjectStoreResetMenuBarMenu = () => {
  const { t } = useTranslation();
  const { periodFilter } = useProjectStoreContext();

  const resetPeriodFilter = useCallback(() => {
    if (periodFilter.options.length > 0) {
      periodFilter.setFromDate(periodFilter.options[0]);
      periodFilter.setToDate(
        periodFilter.options[periodFilter.options.length - 1],
      );
    }
  }, [periodFilter]);

  const additionalResetItems: AdditionalResetItem[] = useMemo(
    () => [
      {
        label: t("listMenubar.reset.resetPeriodFilter"),
        onReset: resetPeriodFilter,
      },
    ],
    [t, resetPeriodFilter],
  );

  return <List.Menubar.Reset additionalResetItems={additionalResetItems} />;
};
